import React, { Component } from 'react';
import styled from 'styled-components';
import { Transition } from 'react-transition-group';

const transitionDuration = 500;

const OuterContainer = styled.div`
  position: relative;
  width: 100%
  background: #F0F3F6;
  height: ${(props) => props.height || '8px'};
  border-radius: 24px;
  margin-top: ${(props) => props.marginTop || '32px'};
`;

const ProgressContainer = styled.div`
  width: ${(props) => props.width || '1%'};
  height: ${(props) => props.height || '8px'};
  transition: ${() => `width ${transitionDuration}ms ease-in-out`};
  top: 0;
  left: 0;
  bottom: 0;
  background: ${(props) => props.color || '#1eb865'};
  border-radius: 24px;
`;

export default class ProgressBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      transition: false,
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ transition: true });
    }, 500);
  }

  render() {
    const { width, height, className, gradient, marginTop, color } = this.props;
    const { transition } = this.state;
    const transitionWidth = {
      entering: '1%',
      entered: width || '1%',
      exiting: '0%',
      exited: '0%',
    };
    return (
      <OuterContainer
        marginTop={marginTop}
        height={height}
        className={className}
      >
        <Transition in={transition} timeout={transitionDuration}>
          {(state) => (
            <ProgressContainer
              width={transitionWidth[state]}
              height={height}
              color={color}
            />
          )}
        </Transition>
      </OuterContainer>
    );
  }
}
